module.exports = __webpack_public_path__ + "img/nav-design-collectionrings.ea23849.jpg";